module.exports = __webpack_public_path__ + "img/campaign-registered-icon.4ac8216d.svg";